export const getBaseApi = () => {
  return process.env.REACT_APP_BASE_URL || "https://api.live100.ai/api/";
};